<ngx-simplebar class="responsiveScrollContainer h-full">
  <div class="container gateStatusDetail">
    <ngx-simplebar [options]="{ autoHide: false }" class="widget p-2" id="gateFaults">
      <app-gate-fault-table [gateFaults]="statusFacade.activeGateFaultState()"></app-gate-fault-table>
    </ngx-simplebar>

    <ngx-simplebar
      [options]="{ autoHide: false }"
      id="gateFaultFrequency"
      class="widget flex flex-column p-3 gap-2 align-items-center justify-content-center"
    >
      <app-gate-fault-frequency
        [aspectRatio]="1.2"
        [gateFaultSource]="statusFacade.allGateFaultState()"
        chartId="gateStatusFaultFrequency"
      ></app-gate-fault-frequency>
    </ngx-simplebar>
    <ngx-simplebar id="gatePosition" [options]="{ autoHide: false }" class="widget">
      <app-gate-position
        [compact]="true"
        [gateStatus]="statusFacade.gateStatus()"
        [timeout]="statusFacade.gateStatusTimeout()"
      ></app-gate-position>
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false }" class="widget" id="expectedEnergyLoss">
      <app-expected-energy-loss
        [energyLoss]="statusFacade.energyLoss()"
        [expectedEnergyLossPerDay]="statusFacade.expectedEnergyLossPerDay()"
        [compact]="true"
      ></app-expected-energy-loss>
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false }" class="widget" id="predictiveServiceList">
      @if (gateSystemId()) {
        <app-service-list
          [asset]="{
            id: gateSystemId(),
            assetType: assetTypes.GATE_SYSTEM,
          }"
          type="predictive"
        >
        </app-service-list>
      }
    </ngx-simplebar>
    <ngx-simplebar [options]="{ autoHide: false }" class="widget" id="contractsServiceList">
      @if (gateSystemId()) {
        <app-service-list
          [asset]="{
            id: gateSystemId(),
            assetType: assetTypes.GATE_SYSTEM,
          }"
          type="contracts"
        >
        </app-service-list>
      }
    </ngx-simplebar>
    @if (timeOutMap()) {
      <div class="widget" id="timeout">
        <app-timeout></app-timeout>
      </div>
    } @else if (loadingMap()) {
      <div class="widget w-full flex justify-content-center align-items-center h-full" id="progressSpinner">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    }
    <div class="widget" [ngClass]="{ hide: loadingMap() || timeOutMap() }" id="statusMap"></div>
  </div>
</ngx-simplebar>
